import script from "./ArticleItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleItem.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleItem.vue?vue&type=style&index=0&id=7d137ce4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d137ce4"]])

export default __exports__